import React from "react";
import LanguageSelect from "~/components/input/selects/LanguageSelect.jsx";
import MultipleLanguageSelect from "~/components/input/selects/MultipleLanguageSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import { getBrandReturnAppLiveUrl } from "~/cores/appCore";
import TurnrLink from "~/components/links/TurnrLink";

export default function LanguageSettings(props) {
    const { iFrameData, appProps } = props;
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <MultipleLanguageSelect
                    appProps={appProps}
                    size={"medium"}
                    multiple
                    fullWidth={true}
                    tooltip="These are the selectable languages for your customers while they go through the return app"
                    {...props.enabledLanguages}
                    onChange={props.setEnabledLanguages}
                    label="Enabled languages"
                    languageCodes={iFrameData?.languages || iFrameData?.defaultLanguages || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <LanguageSelect
                    size={"medium"}
                    fullWidth={true}
                    appProps={appProps}
                    tooltip={
                        <div>
                            Note that this is just the default language. The user still have the ability to change language as can be seen on the preview
                            <br />
                            <br />
                            You can override this in the query params like this: <TurnrLink href={getBrandReturnAppLiveUrl(appProps) + "/?lang=SV"} />
                        </div>
                    }
                    {...props.defaultLanguage}
                    onChange={props.setDefaultLanguage}
                    label="Default Language"
                    options={props.enabledLanguages?.value?.length > 0 ? props.enabledLanguages?.value : iFrameData?.languages || iFrameData?.defaultLanguages || []}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
